import { Injectable } from "@angular/core";
import { Http, RequestOptions, Response } from "@angular/http";
import "rxjs/add/observable/of";
import "rxjs/add/observable/throw";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/map";
import { Observable } from "rxjs/Observable";
import { TestOrder } from "../../models";
import { UtilService } from "../util";

@Injectable()
export class TestOrderService {
  constructor(private http: Http, private utilService: UtilService) {}

  getICDCodes(
    searchField?: string,
    option?: string
  ): Observable<Array<ICDCode>> {
    let url = "/workbook/icd_codes";
    url = option ? url + "?order=" + option : url;
    if (searchField) {
      url += `?q=${searchField}`;
    }

    return this.http
      .get(url)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  getCovidICDCodes(
    searchField?: string
  ): Observable<Array<ICDCode>> {
    let url = "/workbook/icd_codes?tags=sars-cov-2";
    if (searchField) {
      url += `&q=${searchField}`;
    }
    return this.http
    .get(url)
    .map((res: Response) => JSON.parse(res["_body"]))
    .catch(this.utilService.handleError);
   }

  getCategories(): Observable<Array<TestCategory>> {
    return this.http
      .get("/categories")
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }



  getAllTestOrders(
    searchCriteria: SearchCriteria
  ): Observable<Array<CreatedTestOrder>> {
    let queryParams = this.utilService.setQueryParams({
      q: searchCriteria.SearchTerm,
      sort: searchCriteria.Sort,
      order: searchCriteria.Order,
      page: searchCriteria.PageNumber
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get("/encounters", options)
      .map((res: Response) => res.json())
      .catch(this.utilService.handleError);
  }

  getAllFavoritePanels(searchField: string): Observable<any> {
    let url = "/panels/favorites";
    let queryParams = this.utilService.setQueryParams({
      q: searchField
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get(url, options)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  getAllTests(searchField: string): Observable<any> {
    let url = "/panels";
    let queryParams = this.utilService.setQueryParams({
      q: searchField
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http
      .get(url, options)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  getTestsByCategoryId(
    categoryId: string,
    searchField: string
  ): Observable<any> {
    let url = `/categories/${categoryId}/panels`;
    let queryParams = this.utilService.setQueryParams({
      q: searchField
    });
    let options = new RequestOptions({ params: queryParams });

    return this.http
      .get(url, options)
      .map((res: Response) => JSON.parse(res["_body"]))
      .catch(this.utilService.handleError);
  }

  createTestOrder(testOrder: TestOrder): Observable<Response> {
    let testOrderPayload = {
      PatientId: testOrder.PatientId,
      ICDCodes: testOrder.ICDCodeIds,
      Panels: testOrder.PanelGuids,
      ProviderId: testOrder.PhysicianId,
      ReleasedOn: testOrder.ReleaseOn,
      FacilityId: testOrder.LocationId,
      Attestation: testOrder.Attestation,
      PaymentReceiptToken: testOrder.PaymentReceiptToken,
      PaymentId: testOrder.PaymentId,
      SystemId: testOrder.TempPatient.Systems[0].Id
    };
    return this.http
      .post("/chart/encounters", testOrderPayload)
      .catch(this.utilService.handleError);
  }

  deleteTestOrder(encounter_guid: string): Observable<any> {
    return this.http
      .delete(`/chart/encounters/${encounter_guid}`)
      .catch(this.utilService.handleError);
  }

  setStatus(status: string, orderId: number, patientId: number) {
    let statusToEndpointMapping = {
      pending: "abort"
    };
    let url =
      `/patient/${patientId}/order/${orderId}/` +
      statusToEndpointMapping[status];
    return this.http.post(url, {}).catch(this.utilService.handleError);
  }

  recordTestOrderReportView(reportId: number) {
    return this.http
      .get(`/encounters/${reportId}/report`)
      .catch(this.utilService.handleError);
  }

  favoritePanel(panelId: number): Observable<Response> {
    return this.http
      .put(`/panels/${panelId}/favorites`, {})
      .catch(this.utilService.handleError);
  }

  unfavoritePanel(panelId: number): Observable<Response> {
    return this.http
      .delete(`/panels/${panelId}/favorites`)
      .catch(this.utilService.handleError);
  }

  createFavoriteICD(favIcdId: string): Observable<Response> {
    const url =
      "/core/favorites?favoriteable_id=" +
      favIcdId +
      "&favoriteable_type=IcdCode";

    const payload = {};
    return this.http.post(url, payload).catch(this.utilService.handleError);
  }

  getAllFavoriteIcdCodes(): Observable<ICDCode> {
    let url = "/core/favorites/";

    let queryParams = this.utilService.setQueryParams({
      favoriteable_type: "IcdCode"
    });
    let options = new RequestOptions({ params: queryParams });
    return this.http.get(url, options).catch(this.utilService.handleError);
  }

  unfavoriteICD(favId: string): Observable<Response> {
    return this.http
      .delete(
        `/core/favorites/${favId}?favoriteable_id=${favId}&favoriteable_type=IcdCode`
      )
      .catch(this.utilService.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/test-order/test-order.service.ts